import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Vue from 'vue';

Vue.component('DatePicker', DatePicker);
